import { STATE_MAP } from './constants';

export const getUSState = (stateProvince: string): string =>
  STATE_MAP[stateProvince] || stateProvince;

export const getUSStateName = (stateProvince: string): string => {
  const trimmed = stateProvince?.trim();
  if (!trimmed) {
    return '';
  }

  const stateName = Object.keys(STATE_MAP).find(
    name => name.toLowerCase() === trimmed.toLowerCase()
  );
  if (stateName) {
    return stateName;
  }

  return (
    Object.entries(STATE_MAP).find(
      ([, abbreviation]) => abbreviation.toLowerCase() === trimmed.toLowerCase()
    )?.[0] ?? trimmed
  );
};

export const expandUSStateAbbreviationsInAddress = (address: string | null | undefined): string => {
  if (!address) {
    return '';
  }

  const parts = address.split(',');
  return parts
    .map(part => {
      const trimmed = part.trim();
      if (!/^[A-Z]{2}$/i.test(trimmed)) {
        return trimmed;
      }

      return getUSStateName(trimmed);
    })
    .filter(Boolean)
    .join(', ');
};
